(function () {
  'use strict';
  var pdp = document.querySelector('[data-fx-product]');
  var jsonEl = document.querySelector('[data-fx-product-json]');
  var gallery = document.querySelector('.fx-gallery');
  if (!pdp || !jsonEl || !gallery) return;
  var product = JSON.parse(jsonEl.textContent);
  var fieldsets = pdp.querySelectorAll('[data-fx-option]');
  var base = function (src) {
    if (!src) return '';
    var f = String(src).split('?')[0].split('/').pop();
    return f.replace(/_\d+x\d*(?=\.)/, '').replace(/\.[a-z]+$/i, '');
  };
  var current = function () {
    var opts = Array.prototype.map.call(fieldsets, function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
    return product.variants.find(function (v) {
      return v.options.every(function (o, i) { return opts[i] === o; });
    });
  };
  var showVariantImage = function () {
    var v = current();
    if (!v || !v.featured_image) return;
    var key = base(v.featured_image.src);
    var figures = gallery.querySelectorAll('.fx-gallery__item');
    for (var i = 0; i < figures.length; i++) {
      var img = figures[i].querySelector('img');
      if (img && base(img.getAttribute('src')).indexOf(key) === 0) {
        if (i > 0) gallery.insertBefore(figures[i], gallery.firstChild);
        gallery.scrollLeft = 0;
        return;
      }
    }
  };
  fieldsets.forEach(function (fs) { fs.addEventListener('change', showVariantImage); });
  showVariantImage();
})();
